import {
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DescriptionIcon from "@mui/icons-material/Description";
import StorageIcon from "@mui/icons-material/Storage";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

import SummarizeIcon from "@mui/icons-material/Summarize";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import Collapse from "@mui/material/Collapse";
import "../assets/css/style.css";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";

// employees menu icons
import BadgeIcon from "@mui/icons-material/Badge";
import TodayIcon from "@mui/icons-material/Today";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import EventBusyIcon from "@mui/icons-material/EventBusy";
// purchase order menu icons
import ShoppingCartRounded from "@mui/icons-material/ShoppingCartRounded";
import ListAltRounded from "@mui/icons-material/ListAltRounded";
import NoteAddRounded from "@mui/icons-material/NoteAddRounded";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
//Invoices menu icons
import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
// Masters menu icons
import GroupRounded from "@mui/icons-material/GroupRounded";
import StorefrontRounded from "@mui/icons-material/StorefrontRounded";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import InventoryRounded from "@mui/icons-material/InventoryRounded";
// configuration menu icons
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import BusinessIcon from "@mui/icons-material/Business";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaidIcon from "@mui/icons-material/Paid";
// report menu icons
import SummarizeRounded from "@mui/icons-material/SummarizeRounded";
import TimelineRounded from "@mui/icons-material/TimelineRounded";
import PaymentIcon from "@mui/icons-material/Payment";
import BeachAccessRounded from "@mui/icons-material/BeachAccessRounded";
import PunchClockRounded from "@mui/icons-material/PunchClockRounded";
import TrackChangesRounded from "@mui/icons-material/TrackChangesRounded";
import RequestQuoteRounded from "@mui/icons-material/RequestQuoteRounded";
import HowToRegRounded from "@mui/icons-material/HowToRegRounded";

import Tooltip from "@mui/material/Tooltip";

import {
  EventNoteRounded,
  PaymentRounded,
  Timeline,
} from "@mui/icons-material";

function Sidenav({ isSidebarOpen }) {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const activeUrl = window.location.pathname;
  const [generalMenu, setGeneralMenu] = useState([]);
  const [MenuManagement, setmenuManagement] = useState([]);
  const [UserMenu, setuserMenu] = useState([]);
  const useRefApp = useRef(false);
  const userData = JSON.parse(localStorage.getItem("user"));

  // const handleClick = (id) => {
  //   if (selectedIndex === id) {
  //     setSelectedIndex("");
  //   } else {
  //     setSelectedIndex(id);
  //   }
  // };

  const handleClick = (index) => {
    const isParentMenuItem = index < generalMenu.length;
    const parentIndex = isParentMenuItem
      ? index
      : Math.floor(index / generalMenu.length);

    if (!isParentMenuItem && selectedIndex != parentIndex) {
      setSelectedIndex(parentIndex);
    } else {
      setSelectedIndex((prevIndex) => (prevIndex == index ? null : index));
    }
  };

  const findIndex = (arr, path) => {
    let foundIndex = -1;

    arr.forEach((item, index) => {
      if (item.url == path) {
        foundIndex = index;
      } else if (item.childMenu) {
        item.childMenu.forEach((childItem, childIndex) => {
          if (childItem.url == path) {
            foundIndex = index;
          }
        });
      }
    });

    return foundIndex + 1;
  };

  useEffect(() => {
    if (useRefApp.current === false) {
      setGeneralMenu([
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: <DonutSmallIcon />,
          childMenuFlag: false,
        },
      ]);

      setuserMenu([
        {
          title: "Attendance",
          url: "/user/attendance",
          // icon: <SupervisedUserCircleIcon />,
          childMenuFlag: false,
        },
        {
          title: "Apply Leave",
          url: "/user/apply-leave",
          // icon: <TaskIcon />,
          childMenuFlag: false,
        },
        // {
        //   title: "Payment Request",
        //   url: "/user/payment/request",
        //   // icon: <CurrencyRupeeIcon />,
        //   childMenuFlag: false,
        // },
        // {
        //   title: "Payment List",
        //   url: "/user/payment/list",
        //   // icon: <ReceiptIcon />,
        //   childMenuFlag: false,
        // },
        {
          title: "Labour Attendance",
          url: "/user/labour-attend",
          // icon: <TaskIcon />,
          childMenuFlag: false,
        },
      ]);
      const variable = [
        {
          title: "HR Management",
          url: "#",
          icon: <ManageAccountsIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            { icon: <BadgeIcon />, title: "Employees", url: "/employee/list" },
            {
              icon: <TodayIcon />,
              title: "Employee Attendance",
              url: "/employee-attendance",
            },
            // { icon: <RequestPageIcon />, title: 'PaySlip', url: '/payslip' },
            {
              icon: <RequestQuoteIcon />,
              title: "PaySlip Report",
              url: "/payslip-report",
            },
            {
              icon: <EventBusyIcon />,
              title: "Leave Approval",
              url: "/Leave/approval",
            },
          ],
        },
        {
          title: "Purchase Order",
          url: "#",
          icon: <DescriptionIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <ShoppingCartRounded />,
              title: "Purchase Order",
              url: "/purchase-order/create",
            },
            {
              icon: <ListAltRounded />,
              title: "List Purchase Order",
              url: "/purchase-order/list",
            },
            {
              icon: <NoteAddRounded />,
              title: "P.O Add Terms & Conditions",
              url: "/termsandconditions/add",
            },
            {
              icon: <DescriptionRounded />,
              title: "P.O List Terms & Conditions",
              url: "/termsandconditions/list",
            },
          ],
        },
        {
          title: "Invoice",
          url: "#",
          icon: <DescriptionIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <ReceiptLongRounded />,
              title: "Create Invoice",
              url: "/invoice/create",
            },
            {
              icon: <ListAltRounded />,
              title: "Invoice List",
              url: "/invoice/list",
            },
            {
              icon: <NoteAddRounded />,
              title: "Invoice Add Terms & Conditions",
              url: "/invoiceTermsAndConditions/add",
            },
            {
              icon: <DescriptionRounded />,
              title: "Invoice List Terms & Conditions",
              url: "/invoiceTermsAndConditions/list",
            },
          ],
        },
        {
          title: "Masters",
          url: "#",
          icon: <StorageIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            { icon: <GroupRounded />, title: "Clients", url: "/client/list" },
            {
              icon: <WorkOutlineIcon />,
              title: "Projects",
              url: "/project/list",
            },
            {
              icon: <StoreMallDirectoryIcon />,
              title: "Store",
              url: "/store/list",
            },
            {
              icon: <StorefrontRounded />,
              title: "Vendor",
              url: "/vendor/list",
            },
            {
              icon: <InventoryRounded />,
              title: "Payment Request",
              url: "/payment-request/list",
            },
            // { title: "Add Client", url: "/client/add" },
            // { title: "List Clients", url: "/client/list" },
            // { title: "Add Project", url: "/project/add" },
            // { title: "List Projects", url: "/project/list" },
            // { title: "Add Store", url: "/store/add" },
            // { title: "List Store", url: "/store/list" },
            // { title: "Add Vendor", url: "/vendor/create" },
            // { title: "List Vendors", url: "/vendor/list" },
            // { title: "List Payment Request", url: "/payment-request/list" },
          ],
        },
        {
          title: "Configurations",
          url: "#",
          icon: <ToggleOnIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <SettingsRounded />,
              title: "Configuration",
              url: "/config/configuration",
            },
            {
              icon: <BusinessIcon />,
              title: "Manage Departments",
              url: "/config/departments-master",
            },
            {
              icon: <WorkOutlineIcon />,
              title: "Manage Positions",
              url: "/config/positions-master",
            },
            {
              icon: <AttachMoneyIcon />,
              title: "Manage Allowances",
              url: "/manage-allowances",
            },
            {
              icon: <EventNoteRounded />,
              title: "Manage Holidays",
              url: "/add-holiday",
            },
            {
              icon: <BusinessIcon />,
              title: "Manage Companies",
              url: "/manage-companies/list",
            },
            // { title: "List Companies", url: "/manage-companies/list" },
            {
              icon: <PaidIcon />,
              title: "Manage Labour Wages",
              url: "/config/labour-wages",
            },
          ],
        },

        // Accounting Menu
        {
          title: "Accounting",
          url: "#",
          icon: <AttachMoneyIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <PaymentIcon />,
              title: "Project Payment Report",
              url: "/reports/project-payment-report",
            },
            {
              icon: <AttachMoneyIcon />,
              title: "Employee Payment Report",
              url: "/payment/list",
            },
            {
              icon: <RequestQuoteRounded />,
              title: "Advance Payment Report",
              url: "/advance-payment/list",
            },
            {
              title: "Weekly Payment Report",
              url: "/weeklyReport",
              icon: <PunchClockRounded />,
            },
          ],
        },

        // Reports Menu
        {
          title: "Reports",
          url: "#",
          icon: <SummarizeIcon />,
          childMenuFlag: true,
          menuOpenFlag: false,
          childMenu: [
            {
              icon: <SummarizeRounded />,
              title: "Project Summary Report",
              url: "/reports/project-summary",
            },
            {
              icon: <TimelineRounded />,
              title: "Project Timeline Report",
              url: "/reports/project-report",
            },
            {
              icon: <TrackChangesRounded />,
              title: "Employee Activity Report",
              url: "/reports/employee-activity-report",
            },
            {
              icon: <HowToRegRounded />,
              title: "Employee Attendance Report",
              url: "/reports/employee-attendance-report",
            },
            {
              icon: <BeachAccessRounded />,
              title: "Leave Report",
              url: "/reports/leave-report",
            },
            {
              icon: <PunchClockRounded />,
              title: "Labour Attendance Report",
              url: "/user/labour-attend",
            },
            {
              title: "Weekly Plan Schedule",
              url: "/weeklyPlanSchedule",
              icon: <PunchClockRounded />,
            },
          ],
        },

        {
          title: "Announcement",
          url: "/announcement",
          icon: <CampaignRoundedIcon />,
          childMenuFlag: false,
        },
      ];

      setmenuManagement(variable);

      const pathname = window.location.pathname;
      const idx = findIndex(variable, pathname);
      setSelectedIndex(idx);
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  useEffect(() => {}, [isSidebarOpen]);

  return (
    <>
      {userData.role_id === 35 || userData.role_id === 34 ? (
        <>
          {/* ── generalMenu (Dashboard only usually) ── */}
          <Grid>
            {generalMenu.map((row, index) => (
              <React.Fragment key={index}>
                {row.childMenuFlag ? (
                  <>
                    <ListItemButton
                      className="menu_id"
                      onClick={() => handleClick(index)}
                      sx={{
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        px: isSidebarOpen ? 2.5 : 0,
                        minHeight: 48,
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <>
                          <ListItemText
                            primary={row.title}
                            sx={{ whiteSpace: "nowrap" }}
                          />
                          {index === selectedIndex ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </>
                      )}
                    </ListItemButton>
                    {isSidebarOpen && (
                      <Collapse
                        in={index === selectedIndex}
                        timeout="auto"
                        unmountOnExit
                      >
                        {row.childMenu.map((submenu, subIndex) => (
                          <Link
                            to={submenu.url}
                            key={subIndex}
                            className={`sidemenu--item ${activeUrl === submenu.url ? "active" : ""}`}
                          >
                            <ListItemButton
                              sx={{ minHeight: 44, pl: 4, pr: 2 }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 1.5,
                                  justifyContent: "center",
                                }}
                              >
                                {submenu.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={submenu.title}
                                sx={{ "& span": { fontSize: "13px" } }}
                              />
                            </ListItemButton>
                          </Link>
                        ))}
                      </Collapse>
                    )}
                  </>
                ) : (
                  <Link
                    to={row.url}
                    key={index}
                    className={`sidemenu--item ${activeUrl === row.url ? "active" : ""}`}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        px: isSidebarOpen ? 2.5 : 0,
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <ListItemText
                          primary={row.title}
                          sx={{ whiteSpace: "nowrap" }}
                        />
                      )}
                    </ListItemButton>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </Grid>

          {/* ── MenuManagement ── */}
          <Grid>
            {MenuManagement.map((row, index) => (
              <React.Fragment key={index}>
                {row.childMenuFlag ? (
                  <>
                    <ListItemButton
                      className={`menu_id ${selectedIndex - 1 === index ? "active" : ""}`}
                      onClick={() => handleClick(index + generalMenu.length)}
                      sx={{
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        px: isSidebarOpen ? 2.5 : 0,
                        minHeight: 48,
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <>
                          <ListItemText
                            primary={row.title}
                            sx={{ whiteSpace: "nowrap" }}
                          />
                          {index + generalMenu.length === selectedIndex ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </>
                      )}
                    </ListItemButton>
                    {isSidebarOpen && (
                      <Collapse
                        in={index + generalMenu.length === selectedIndex}
                        timeout="auto"
                        unmountOnExit
                      >
                        {row.childMenu.map((submenu, subIndex) => (
                          <Link
                            to={submenu.url}
                            key={subIndex}
                            className={`sidemenu--item ${activeUrl === submenu.url ? "active" : ""}`}
                          >
                            <ListItemButton
                              sx={{ minHeight: 44, pl: 4, pr: 2 }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 1.5,
                                  justifyContent: "center",
                                }}
                              >
                                {submenu.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={submenu.title}
                                sx={{ "& span": { fontSize: "13px" } }}
                              />
                            </ListItemButton>
                          </Link>
                        ))}
                      </Collapse>
                    )}
                  </>
                ) : (
                  <Link
                    to={row.url}
                    key={index}
                    className={`sidemenu--item ${activeUrl === row.url ? "active" : ""}`}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        px: isSidebarOpen ? 2.5 : 0,
                        justifyContent: isSidebarOpen ? "flex-start" : "center",
                        width: "100%",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: isSidebarOpen ? 2 : 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      {isSidebarOpen && (
                        <ListItemText
                          primary={row.title}
                          sx={{ whiteSpace: "nowrap" }}
                        />
                      )}
                    </ListItemButton>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </Grid>
        </>
      ) : (
        <></>
      )}

      {userData.role_id === 36 ? (
        <Grid>
          {UserMenu.map((row, id) =>
            row.childMenuFlag ? (
              <React.Fragment key={id}>
                <ListItemButton
                  className="menu_id"
                  onClick={() => handleClick(id)}
                  sx={{
                    justifyContent: isSidebarOpen ? "flex-start" : "center",
                    px: isSidebarOpen ? 2.5 : 0,
                    minHeight: 48,
                    width: "100%",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSidebarOpen ? 2 : 0,
                      justifyContent: "center",
                    }}
                  >
                    {row.icon}
                  </ListItemIcon>
                  {isSidebarOpen && (
                    <>
                      <ListItemText
                        primary={row.title}
                        sx={{ whiteSpace: "nowrap" }}
                      />
                      {id === selectedIndex ? <ExpandLess /> : <ExpandMore />}
                    </>
                  )}
                </ListItemButton>
                {isSidebarOpen && (
                  <Collapse
                    in={id === selectedIndex}
                    timeout="auto"
                    unmountOnExit
                  >
                    {row.childMenu.map((submenu, subId) => (
                      <Link
                        to={submenu.url}
                        key={subId}
                        className={`sidemenu--item ${activeUrl === "" + submenu.url ? "active" : ""}`}
                      >
                        <ListItemButton sx={{ minHeight: 44, pl: 4, pr: 2 }}>
                          <ListItemText primary={submenu.title} />
                        </ListItemButton>
                      </Link>
                    ))}
                  </Collapse>
                )}
              </React.Fragment>
            ) : (
              <Link
                to={row.url}
                key={id}
                className={`sidemenu--item ${activeUrl === "" + row.url ? "active" : ""}`}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    px: isSidebarOpen ? 2.5 : 0,
                    justifyContent: isSidebarOpen ? "flex-start" : "center",
                    width: "100%",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSidebarOpen ? 2 : 0,
                      justifyContent: "center",
                    }}
                  >
                    {row.icon}
                  </ListItemIcon>
                  {isSidebarOpen && (
                    <ListItemText
                      primary={row.title}
                      sx={{ whiteSpace: "nowrap" }}
                    />
                  )}
                </ListItemButton>
              </Link>
            ),
          )}
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
export default Sidenav;
